import { render, staticRenderFns } from "./ProductCardPreviewAudio.vue?vue&type=template&id=25f17f0c&scoped=true&"
import script from "./ProductCardPreviewAudio.vue?vue&type=script&lang=js&"
export * from "./ProductCardPreviewAudio.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardPreviewAudio.vue?vue&type=style&index=0&id=25f17f0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f17f0c",
  null
  
)

export default component.exports